import { ParlorHeader } from "@/containers/ParlorDetailContainer/components/ParlorHeader";
import { DirectionsHero } from "./components/DirectionsHero";
import { DirectionsMap } from "./components/DirectionsMap";
import { DirectionsTransit } from "./components/DirectionsTransit";
import { DirectionsDriving } from "./components/DirectionsDriving";
import { DirectionsAmenities } from "./components/DirectionsAmenities";
import { DirectionsLeadCTA } from "./components/DirectionsLeadCTA";
import { DirectionsFixedBar } from "./components/DirectionsFixedBar";
import { DirectionsCrossLink } from "./components/DirectionsCrossLink";
import { DirectionsNearby } from "./components/DirectionsNearby";
import { DirectionsFAQ } from "./components/DirectionsFAQ";
import { DirectionsIntentBridge } from "./components/DirectionsIntentBridge";
import { DirectionsCostGauge } from "./components/DirectionsCostGauge";
import { customEvent } from "goi_common";
import { useParlorInquiryModal } from "@/hooks/useParlorInquiryModal";

interface NearbyParlor {
  id: number;
  companyname: string;
  sido: string;
}

interface DirectionsDetailContainerProps {
  parlorId: number;
  companyName: string;
  sidoCode: string;
  sigunguCode: string;
  costMubinso: number | null;
  costFamily: number | null;
  costGeneral: number | null;
  sidoName: string;
  sigunguName: string;
  address: string;
  telephone: string;
  latitude?: number;
  longitude?: number;
  hasCoordinates: boolean;
  traffpublic: string;
  traffowner: string;
  parkcnt: number;
  amenities: Record<string, boolean | number>;
  nearbyParlors: NearbyParlor[];
}

export const DirectionsDetailContainer = ({
  parlorId,
  companyName,
  sidoCode,
  sigunguCode,
  costMubinso,
  costFamily,
  costGeneral,
  sidoName,
  sigunguName,
  address,
  telephone,
  latitude,
  longitude,
  hasCoordinates,
  traffpublic,
  traffowner,
  parkcnt,
  amenities,
  nearbyParlors,
}: DirectionsDetailContainerProps) => {
  const { openParlorInquiryModal } = useParlorInquiryModal("prlr_directions");
  const hasParkinglot = amenities["has_parkinglot"] === true;

  return (
    <div className="dr-page">
      <ParlorHeader
        hidePhoneStrip
        onPhoneStripClick={() => {
          customEvent({
            newGtm: {
              path: "prlr_directions",
              trigger_and_target: "hdr_consult",
            },
          });
          void openParlorInquiryModal();
        }}
      />
      <DirectionsHero
        companyName={companyName}
        sidoName={sidoName}
        sigunguName={sigunguName}
        address={address}
        telephone={telephone}
      />

      <div className="dr-main">
        <DirectionsIntentBridge parlorId={parlorId} companyName={companyName} />

        {hasCoordinates && latitude && longitude && (
          <DirectionsMap
            latitude={latitude}
            longitude={longitude}
            companyName={companyName}
            address={address}
          />
        )}

        <DirectionsTransit
          companyName={companyName}
          traffpublic={traffpublic}
        />

        {costMubinso !== null && costFamily !== null && costGeneral !== null && (
          <section className="dr-cost-gauge-band" aria-label="예상 비용 확인">
            <DirectionsCostGauge
              parlorId={parlorId}
              companyName={companyName}
              sidoCode={sidoCode}
              sigunguCode={sigunguCode}
              costMubinso={costMubinso}
              costFamily={costFamily}
              costGeneral={costGeneral}
            />
          </section>
        )}

        <DirectionsDriving
          companyName={companyName}
          traffowner={traffowner}
          parkcnt={parkcnt}
          hasParkinglot={hasParkinglot}
        />

        <DirectionsAmenities companyName={companyName} amenities={amenities} />

        <DirectionsCrossLink parlorId={parlorId} companyName={companyName} />

        <DirectionsNearby
          companyName={companyName}
          sigunguName={sigunguName}
          nearbyParlors={nearbyParlors}
        />

        <DirectionsFAQ
          companyName={companyName}
          address={address}
          telephone={telephone}
          parkcnt={parkcnt}
          hasParkinglot={hasParkinglot}
          sigunguName={sigunguName}
        />

        <DirectionsLeadCTA
          parlorId={parlorId}
          companyName={companyName}
          position="bottom"
        />
      </div>

      <DirectionsFixedBar parlorId={parlorId} companyName={companyName} />
    </div>
  );
};
